import React, { useContext, useEffect, useRef } from "react";
import hark from "../../helpers/hark";
import { useDispatch } from "react-redux";
import RoomContext from "../../context/RoomContext";
import * as peerVolumeActions from "../../actions/peerVolumeActions";

let _audioTrack = null;
let _audioOutputDevice = null;

const PeerAudio = ({ peerId, audioTrack, audioOutputDevice }) => {
  const { roomClient } = useContext(RoomContext);
  const dispatch = useDispatch();
  const audioRef = useRef(null);

  useEffect(() => {
    const _setTrack = (audioTrack) => {
      if (_audioTrack === audioTrack) return;

      _audioTrack = audioTrack;

      if (audioTrack) {
        const stream = new MediaStream();

        if (audioTrack) stream.addTrack(audioTrack);
        if (audioRef && audioRef.current) audioRef.current.volume = 0.3;
        let _hark = hark(stream.clone(), {
          play: false,
          interval: 50,
          threshold: -50,
        });
        _hark.on("speaking", function () {
          if (audioRef && audioRef.current) audioRef.current.volume = 1.0;
          _hark.setInterval(500);
          if (roomClient.getRoomActiveSpeaker() !== peerId)
            roomClient.setRoomActiveSpeaker(peerId);
        });
        _hark.on("stopped_speaking", function () {
          _hark.setInterval(100);

          if (roomClient.getRoomActiveSpeaker() === peerId)
            roomClient.setRoomActiveSpeaker(null);
          if (audioRef && audioRef.current) audioRef.current.volume = 0.3;
        });

        // eslint-disable-next-line no-unused-vars
        _hark.on("volume_change", (dBs, threshold) => {
          // The exact formula to convert from dBs (-100..0) to linear (0..1) is:
          //   Math.pow(10, dBs / 20)
          // However it does not produce a visually useful output, so let exagerate
          // it a bit. Also, let convert it from 0..1 to 0..10 and avoid value 1 to
          // minimize component renderings.
          let volume = Math.round(Math.pow(10, dBs / 85) * 10);

          if (volume === 1) volume = 0;

          volume = Math.round(volume);
          dispatch(peerVolumeActions.setPeerVolume(peerId, volume));
        });

        audioRef.current.srcObject = stream;

        audioRef.current
          .play()
          .catch((error) =>
            console.log('audioRef.current.play() [error:"%o]', error)
          );
      } else {
        audioRef.current.srcObject = null;
      }
    };

    const _setOutputDevice = (audioOutputDevice) => {
      if (_audioOutputDevice === audioOutputDevice) return;

      _audioOutputDevice = audioOutputDevice;

      if (
        audioOutputDevice &&
        typeof audioRef.current.setSinkId === "function"
      ) {
        //audio.setSinkId(audioOutputDevice);
        audioRef.current
          .setSinkId(audioOutputDevice)
          .then(() => {
            console.log(
              `Success, audio output device attached: ${audioOutputDevice}`
            );
          })
          .catch((error) => {
            let errorMessage = error;
            if (error.name === "SecurityError") {
              errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
            }
            console.error(errorMessage);
          });
      }
    };

    _setTrack(audioTrack);
    //_setOutputDevice(audioOutputDevice);
  }, [audioOutputDevice, audioTrack]);
  return <audio ref={audioRef} />;
};

export default PeerAudio;
